import { render, staticRenderFns } from "./routerSetup.vue?vue&type=template&id=08efc62b&scoped=true"
import script from "./routerSetup.vue?vue&type=script&lang=js"
export * from "./routerSetup.vue?vue&type=script&lang=js"
import style0 from "./routerSetup.vue?vue&type=style&index=0&id=08efc62b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efc62b",
  null
  
)

export default component.exports